import React from 'react';

import { CheckCircleOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import { useQuery } from '@tanstack/react-query';

// Importación actualizada: API movida a features/erp/subscriptions/api
import { subscriptionsApi } from '../api/subscriptions.ts';

interface SubscriptionBadgeProps {
  itemId: number;
  customerId?: number | null;
  queryEnabled?: boolean;
}

export const SubscriptionBadge: React.FC<SubscriptionBadgeProps> = ({
  itemId,
  customerId,
  queryEnabled = true,
}) => {
  const enabled = Boolean(customerId) && queryEnabled;
  const { data } = useQuery({
    queryKey: ['subscription-availability', customerId, itemId],
    queryFn: () => subscriptionsApi.getAvailabilityForItem(customerId as number, itemId),
    enabled,
    staleTime: 60_000,
  });

  if (!data || (!data.unlimited && (data.available ?? 0) <= 0)) {
    return null;
  }

  return (
    <Tag
      color="success"
      icon={<CheckCircleOutlined />}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}
    >
      {data.unlimited ? 'Ilimitado' : `${Math.floor(data.available ?? 0)} créditos`}
    </Tag>
  );
};

export default SubscriptionBadge;
